var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnjoyment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pl1fl0lyoa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.031373 0 0 0 0 0.760784 0 0 0 0 0.317647 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pl1fl0lyoa)",
    transform: "translate(-642 -385)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M29.423 20.304c0-2.406 1.958-4.363 4.364-4.363 2.406 0 4.363 1.957 4.363 4.363 0 .692-.56 1.254-1.253 1.254-.693 0-1.254-.562-1.254-1.254 0-1.024-.832-1.856-1.856-1.856-1.023 0-1.857.832-1.857 1.856 0 .692-.561 1.254-1.254 1.254-.692 0-1.253-.562-1.253-1.254zM15.52 20.29c0-2.405 1.958-4.363 4.364-4.363 2.406 0 4.364 1.957 4.364 4.363 0 .693-.561 1.254-1.254 1.254s-1.254-.561-1.254-1.254c0-1.023-.832-1.856-1.856-1.856s-1.857.833-1.857 1.856c0 .693-.56 1.254-1.253 1.254-.693 0-1.254-.561-1.254-1.254zm-.556 11.208c-.319-.767.045-1.647.812-1.966.189-.078.384-.115.577-.115.59 0 1.15.349 1.39.928 1.392 3.353 4.841 5.518 8.787 5.518 3.856 0 7.285-2.167 8.736-5.521.33-.763 1.216-1.115 1.978-.785.762.33 1.113 1.216.783 1.979-1.927 4.456-6.44 7.336-11.498 7.336-5.165 0-9.705-2.894-11.565-7.374zM43.359 52H9.642C4.602 52 .5 47.899.5 42.859V9.142C.5 4.1 4.602 0 9.642 0h33.716C48.4 0 52.5 4.101 52.5 9.142v33.716C52.501 47.899 48.4 52 43.36 52zM9.642 4.302c-2.669 0-4.84 2.171-4.84 4.84v33.716c0 2.668 2.171 4.84 4.84 4.84h33.716c2.669 0 4.84-2.172 4.84-4.84V9.142c0-2.669-2.171-4.84-4.84-4.84H9.642z",
    transform: "translate(642.5 385)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnjoyment);
export default __webpack_public_path__ + "static/media/enjoyment.27851063295a5db62cb544dd4432f6d8.svg";
export { ForwardRef as ReactComponent };